import React from 'react'
import "../style/Navbar.css"
// import {Link} from "react-router-dom"
import data from '../data/data.json'

const searchIcon=<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24"><path d="m19.6 21-6.3-6.3q-.75.6-1.725.95Q10.6 16 9.5 16q-2.725 0-4.612-1.887Q3 12.225 3 9.5q0-2.725 1.888-4.613Q6.775 3 9.5 3t4.613 1.887Q16 6.775 16 9.5q0 1.1-.35 2.075-.35.975-.95 1.725l6.3 6.3ZM9.5 14q1.875 0 3.188-1.312Q14 11.375 14 9.5q0-1.875-1.312-3.188Q11.375 5 9.5 5 7.625 5 6.312 6.312 5 7.625 5 9.5q0 1.875 1.312 3.188Q7.625 14 9.5 14Z"/></svg>

const Navbar = () => {
  return ( 
    <div className='nav'>
      <div className="logo">
       <a href="/">
            <img id='logoImage' src={data.logo} alt="Not" />
        </a>
     </div>
    
       <a href="/miphone" className="navlinks">Mi Phone</a>
       <a href="/redmiphone" className="navlinks">Redmi Phone</a>
       <a href="/tv" className="navlinks">TV</a>
       <a href="/laptops" className="navlinks">Laptops</a>
       <a href="/lifestyle" className="navlinks">Fitness & Lifestyle</a>
       <a href="/home" className="navlinks">Home</a>
       <a href="/audio" className="navlinks">Radio</a>
       <a href="/accessories" className="navlinks">Accessories</a>
    

      <div className="searchbox">
        <input type="text" name='search' placeholder='Search Products' />
        {searchIcon}
      </div>

    </div>
  )
} 

export default Navbar
